import React, { useState, useEffect } from "react";
import "../css/EmailModal.css";
import Loading from "./Loading";
import Success from "./Success";
import Fail from "./Fail";

const EmailModal = ({ onClose }) => {
    const [from, setFrom] = useState("");
    const [message, setMessage] = useState("");
    const [submitState, setSubmitState] = useState("idle");

    useEffect(() => {
        const scriptExists = document.querySelector('script[src="https://www.google.com/recaptcha/api.js"]');
        if (!scriptExists) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js";
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }, []);

    

    const handleSubmit = async (e) => {
        e.preventDefault();

        const recaptchaToken = window.grecaptcha?.getResponse();
        if (!recaptchaToken) {
            alert("Please complete the reCAPTCHA.");
            return;
        }

        setSubmitState("loading");

        try {
            const response = await fetch("https://floteco2.com/api/contact/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: from,
                    message: message,
                    recaptchaToken: recaptchaToken,
                }),
            });

            const data = await response.json();

            if (response.ok && data.message === "Form submitted and email sent successfully!") {
                setSubmitState("success");
            } else {
                setSubmitState("fail");
            }
        } catch (error) {
            console.error("Submission error:", error);
            setSubmitState("fail");
        }
    };

    let bodyContent;
    if (submitState === "loading") bodyContent = <Loading />;
    else if (submitState === "success") bodyContent = <Success onClose={onClose} />;
    else if (submitState === "fail") bodyContent = <Fail onClose={onClose} />;
    else {
        bodyContent = (
            <form onSubmit={handleSubmit} className="email-modal-body">
                <input
                    type="email"
                    placeholder="From"
                    value={from}
                    onChange={(e) => setFrom(e.target.value)}
                    required
                />
                <textarea
                    placeholder="Let us know what you need."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                />
                <div className="recaptcha-wrapper">
                    <div className="g-recaptcha" data-sitekey="6LdPkvgqAAAAAEiiW_9IPLU4XcAX8eXTe9NycIaX"></div>
                </div>
                <div className="email-modal-footer">
                    <button type="submit" className="send-btn">SEND</button>
                    <button type="button" className="cancel-btn" onClick={onClose}>CANCEL</button>
                    <span className="contact-info">
                        Customer Service Email: <a href="mailto:orderdesk@floteco2.com">orderdesk@floteco2.com</a>
                    </span>
                </div>
            </form>
        );
    }

    return (
        <div className="email-modal-overlay">
            <div className="email-modal">
                <div className="email-modal-header">
                    <h3>Email Us</h3>
                    <p>We will reply to your message within a business day.</p>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                {bodyContent}
            </div>
        </div>
    );
};

export default EmailModal;
